
import { Component, Vue } from 'vue-property-decorator';
import ExpandIcon from "@/components/utils/ExpandIcon.vue";
import { GetInstructionFile } from '@/components/utils/GetInstructionFile';

@Component({
    components:{
        ExpandIcon
    }
})
export default class FactumAppealBookRspToAppealPg extends Vue {

    showFactumInfo = true;
    showServedResponseInfo = false;    
    showAppealBookInfo = false;
    showDisagreementInfo = false;
    
    public showFactum(show: boolean){
        if (show) {
            this.showFactumInfo = true;
            this.$emit('adjustHeights', 0, "36rem");
        } else {
            this.showFactumInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showServedResponse(show: boolean){
        if (show) {
            this.showServedResponseInfo = true;
            this.$emit('adjustHeights', 1, "20rem");
        } else {
            this.showServedResponseInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public showAppealBook(show: boolean){
        if (show) {
            this.showAppealBookInfo = true;
            this.$emit('adjustHeights', 2, "31rem");
        } else {
            this.showAppealBookInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

    public showDisagreement(show: boolean){
        if (show) {
            this.showDisagreementInfo = true;
            this.$emit('adjustHeights', 3, "16rem");
        } else {
            this.showDisagreementInfo = false;
            this.$emit('adjustHeights', 3, "0");
        }
    }

    public downloadInstructions(pdf_name){
        GetInstructionFile(pdf_name);        
    }

}
